<div class="flex flex-col justify-start items-stretch gap-y-2">
  <h3 class="pt-4">Site Visit</h3>
  @if (job.site_visit_date) {
    <div class="flex flex-row justify-start items-center gap-x-2">
      <div class="flex flex-col justify-start items-start">
        <p class="m-0">
          Due: {{ job.site_visit_date | amDateFormat: dateFormat }}
        </p>
        <p class="m-0">Address: {{ job.site_visit_address }}</p>
      </div>
      <button
        mat-icon-button
        (click)="openInGoogleMaps(job.site_visit_address, job.site_place_id)"
        matTooltip="Search in Google Maps"
      >
        <mat-icon class="text-blue-500">location_on</mat-icon>
      </button>
    </div>
    <div
      class="flex flex-col xl:flex-row justify-start xl:items-center items-stretch xl:gap-x-2 gap-y-2 xl:gap-y-0"
    >
      <button mat-stroked-button (click)="openSiteVisitDialog()" class="w-full">
        Edit Site Visit
      </button>
      <button
        mat-stroked-button
        (click)="confirmClearSiteVisit()"
        color="warn"
        class="w-full"
      >
        Cancel Site Visit
      </button>
    </div>
  } @else {
    <p class="italic text-center">No site visit scheduled</p>
    <button mat-stroked-button (click)="openSiteVisitDialog()">
      Add Site Visit
    </button>
  }
</div>
